import { QRCodeCanvas } from 'qrcode.react'

interface Props {
  targetString: string
}

export const QrCode: React.FC<Props> = ({ targetString }) => {
  return <QRCodeCanvas value={targetString} size={256} bgColor={'#ffffff'} fgColor={'#000000'} level={'L'} includeMargin={false} />
}
